namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeItemExtForm {
        DiscCouponType: Serenity.StringEditor;
        ListFg: Serenity.IntegerEditor;
        PluCode: Serenity.StringEditor;
        StyleCode: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        SupplCode: Serenity.StringEditor;
    }

    export class PsDiscCouponTypeItemExtForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponTypeItemExt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeItemExtForm.init)  {
                PsDiscCouponTypeItemExtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PsDiscCouponTypeItemExtForm, [
                    'DiscCouponType', w0,
                    'ListFg', w1,
                    'PluCode', w0,
                    'StyleCode', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplCode', w0
                ]);
            }
        }
    }
}
